import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Form from './form'

function AutoMessages({processors, types, facilityTypes}) {
  const [loading, setLoading] = useState(false)

  const renderForm = (processor, typesList) => {
    const { name, form } = processor
    return <Form 
      key={name}
      name={name}
      form={form}
      types={typesList}
      setLoading={(value) => setLoading(value)}
    />
  }

  return <div className={loading ? 'isLoading' : ''}>
    { loading && <div className='animated-spinner'></div> }
    <h2>Auto Messages</h2>
    <br />
    { Object.keys(processors).map(key =>
        renderForm(processors[key], key == 'facility' ? facilityTypes : types)) }
  </div>
}

AutoMessages.propTypes = {
  processors: PropTypes.object.isRequired,
  types: PropTypes.object.isRequired,
  adminTypes: PropTypes.object.isRequired
}

export default AutoMessages
